import { type FC } from "react";

import ResetPasswordForm from "~/features/auth/login/components/ResetPasswordForm";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useResetPasswordLogic } from "~/features/auth/login/hooks/useResetPasswordLogic";
import { useTranslation } from "react-i18next";

interface ResetPasswordPageViewProps {
  onResetSuccess: (globalErrors: string[]) => void;
  initialEmail?: string;
  disableEdit?: boolean;
}

export const ResetPasswordPageView = ({ onResetSuccess, initialEmail, disableEdit }: ResetPasswordPageViewProps) => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle className={"mt-gutter"} title={t("forgottenPwd.title")} />

      <div style={resetPwdBoxStyle}>
        <ResetPasswordForm initialEmail={initialEmail} onSuccess={onResetSuccess} disableEdit={disableEdit} />
      </div>
    </>
  );
};

const ResetPasswordPage: FC = () => {
  const { onResetSuccess } = useResetPasswordLogic();

  return <ResetPasswordPageView onResetSuccess={onResetSuccess} />;
};

const resetPwdBoxStyle = {
  maxWidth: "50%",
};

export function createResetPasswordPage() {
  return <ResetPasswordPage />;
}
